var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 1l8 8m0-8L1 9","stroke":"#737373","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }